<template>
  <div class="options__wrapper" v-if="currentProductInPopup && currentProductInPopup.product_options && currentProductInPopup.product_options.length">
    <template  v-for="option in currentProductInPopup.product_options" :key="option.id">
      <div class="option">
        <!-- v-if="option.show_type_kiosk != 'steps'" -->
        <div class="optionTitle">
          <p>{{option.name}}</p>
          <div class="minMax" v-if="option.type == 'radio' && option.values.length > 1 && option.required">
            <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
                <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="#E2B5BF" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </svg>
              <div>
                <span>{{$t('addOrder.selectMinMax')}}</span> 
                <span>{{$t('addOrder.selectMin')}} 1</span> 
              </div>
          </div>
          <div class="minMax" v-if="option.min_no || option.max_no">
            <svg xmlns="http://www.w3.org/2000/svg" width="19.083" height="19.083" viewBox="0 0 19.083 19.083">
                <path id="Path_49" data-name="Path 49" d="M10.542,2a8.542,8.542,0,1,0,8.542,8.542A8.542,8.542,0,0,0,10.542,2Zm0,4.271a.854.854,0,0,1,.854.854V11.4a.854.854,0,0,1-1.708,0V7.125A.854.854,0,0,1,10.542,6.271Zm0,6.833a.854.854,0,1,1-.854.854A.854.854,0,0,1,10.542,13.1Z" transform="translate(-1 -1)" fill="#E2B5BF" stroke="rgba(251,167,9,0)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
              </svg>
              <div>
                <span>{{$t('addOrder.selectMinMax')}}</span> 
                <span v-if="option.min_no">{{$t('addOrder.selectMin')}} {{option.min_no}}</span> 
                <span v-if="option.max_no">{{$t('addOrder.selectMax')}} {{option.max_no}}</span>
              </div>
          </div>
        </div>
        <div :class="[
            'options',
            option.show_type_kiosk == 'default' ? 'default' : ''
          ]">
          <div v-for="(values, keyVal) in option.values" :key="values.id" 
          :class="[
            option.show_type_kiosk == 'default' ? 'withPhoto' : 'defaultOption'
          ]">
            <label :for="values.id" :class="{ 'checked': values.checked}">
              <template v-if="(option.type === 'checkbox')">
                <input :type="option.type"
                    :ref="'ref_' + values.id"
                    :name="option.id"
                    :disabled="values.disabled"
                    :value="values.id"
                    :id="values.id"
                    @change="updateCategories(option.id, values.id)"
                    v-model="values.checked"
              >
              <button @click="clickOnRef('ref_' + values.id)" :class="values.disabled ? 'disabled' : ''">
                <div class="col-photo">
                  <template v-if="option.show_type_kiosk == 'default'">
                    <div class="opt_photo" :style="'background-image: url('+option.values[keyVal].image+');'" ></div>
                  </template>
                </div>
                <div class="col-value">
                  <span class="valueName">
                    {{values.name}} 
                    <template v-if="!currentProductInPopup.use_price_to_show">
                      <span v-if="values.price > 0" v-html="'+ ' + values.price + ' ' + currentProductInPopup.price_details.currency_symbol"></span>
                    </template>
                  </span>
                </div>
              </button>
              </template>
              <template v-else>
                <input :type="option.type"
                    :ref="'ref_' + values.id"
                    :name="option.id"
                    :value="values.id"
                    :id="values.id"
                    @change="updateCategories(option.id, values.id)"
                    v-model="option.checked"
              >
              <button @click="clickOnRef('ref_' + values.id)">
                <div class="col-photo">
                  <template v-if="option.show_type_kiosk == 'default'">
                    <div class="opt_photo" :style="'background-image: url('+option.values[keyVal].image+');'" ></div>
                  </template>
                </div>
                <div class="col-value">
                  <span class="valueName">
                    {{values.name}} 
                    <template v-if="!currentProductInPopup.use_price_to_show">
                      <span v-if="values.price > 0" v-html="'+ ' + values.price + ' ' + currentProductInPopup.price_details.currency_symbol"></span>
                    </template>
                  </span>
                </div>
              </button>
              </template>

              <!-- <span>{{values.name}} <span v-if="values.price > 0">(+ {{values.price}} {{currentProductInPopup.price_details.currency_symbol}})</span></span> -->
            </label>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
/* eslint-disable */
import { utilsMixin } from '../mixins/utils.js'
export default {
  mixins: [utilsMixin],
  name: 'ProductOptions',
  components: {

  },
  props: {
    currentProductInPopup: Array
  },
  data () {
    return {

    }
  },
  mounted() {

  },
  created () {
    
  },
  methods: {
    updateCategories (opId, valId) {
      this.$emit('updateCategories', opId, valId);
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .mobile {
    .options__wrapper {
      p {
        font-size: 18px;
        font-weight: 500;
        text-transform: initial;
      }
      padding-bottom: 0;
      .option {
        .optionTitle {
          align-items: flex-start;
          flex-direction: column;
          margin-bottom: 20px;
          margin-left: 10px;
        }
        .minMax {
          margin-left: 0px;
          margin-top: 5px;
          color: #E2B5BF;
          span {
            font-size: 15px;
          }
          background: transparent;
          border: 0;
          padding: 0;
        }
        .options {
          label {
            span {
              span {
                font-size: 16px;
                font-weight: 500;
              }
              font-size: 16px;
            }
          }
          button {
            display: flex;
            margin-bottom: 10px;
            min-height: auto;
            padding: 5px;
            border-radius: 50px;
            overflow: hidden;
            .opt_photo {
              width: 50px;
              height: 50px;
              margin-right: 5px;
              @media screen and (max-width: 420px) {
                // height: 70px;
              }
            }
          }
          &.withPhoto {
            margin-left: -10px;
            margin-right: -10px;
          }
          .withPhoto {
            label {
              position: relative;
              &::after {
                content: '';
                background-image: url('../../public/add.svg');
                background-size: contain;
                background-repeat: no-repeat;
                position: absolute;
                top: -10px;
                right: -10px;
                width: 25px;
                height: 25px;
                pointer-events: none;
              }
            }
            label.checked {
              position: relative;
              &::after {
                content: '';
                background-image: url('../../public/check.svg') !important;
                background: #0f6015;
                border: 2px solid #fff;
                background-repeat: no-repeat;
                border-radius: 50px;
                background-position: center;
                background-size: 13px;
                position: absolute;
                top: -10px;
                right: -10px;
                width: 25px;
                height: 25px;
                pointer-events: none;
              }
            }
            button {
              position: relative;
              box-shadow: 0px 4px 12px -7px rgba(0, 0, 0, 0.1);
              .col-photo {
                width: 40%;
              }
              width: 100%;
              justify-content: center;
              align-items: center;
              .valueName {
                min-height: 70px;
                padding: 5px 2px;
                align-items: center;
                justify-content: flex-start;
                text-align: left;
              }
              span {
                font-size: 14px;
                padding: 0px;
                padding-top: 4px;
              }
              border-radius: 10px;
              border: none;
            }
            width: calc(50% - 20px);
            margin-right: 10px;
            margin-left: 10px;
            margin-bottom: 12px;
            @media screen and (max-width: 420px) {
              width: calc(50% - 20px);
            }
          }
          &>div {
            margin-right: 10px;
          }
        }
        @media screen and (max-width: 400px) {
          .optionTitle {
            flex-direction: column;
            align-items: flex-start;
            .minMax {
              margin: 0;
              margin-top: 5px;
            }
          }
        }
      }
    }
  }
  .comp_39 {
    .options__wrapper {
      .option {
        .options {
          input:checked ~ button {
            background-color: #000;
          }
        }
      }
    }
  }
  .options__wrapper {
    display: flex;
    flex-direction: column;
    padding: 20px;
    z-index: 2;
    position: relative;
    p {
      font-size: 1.62rem;
      font-weight: 500;
      text-align: left;
      margin: 0;
      text-transform: uppercase;
    }
    .option {
      margin-bottom: 20px;
      .defaultOption {
        button {
          display: flex;
        }
      }
      .withPhoto {
        button {
          border: 0 !important;
          .name {
            min-height: 55px;
          }
          .price {
            font-weight: bold;
          }
        }
      }
      .optionTitle {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 10px;
      }
      .minMax {
        margin-left: 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #EBEBEB;
        border: 1px solid #E3E3E3;
        border-radius: 10px;
        padding: 5px 15px;
        svg {
          margin-right: 5px;
        }
        span {
          font-size: 1.12rem;
          font-weight: 500;
        }
      }
      .options {
        display: flex;
        flex-wrap: wrap;
        button {
          border-radius: 15px;
          background: #fff;
          color: #000;
          margin-bottom: 20px;
          padding: 10px 15px;
          min-height: 48px;
          width: 100%;
          &.disabled {
            opacity: 0.5;
          }
          .opt_photo {
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            width: 100%;
            height: 120px;
            border-radius: 14px;
          }
        }
        .withPhoto {
          width: calc(25% - 20px);
          margin-right: 10px;
          margin-left: 10px;
        }
        input {
            opacity: 0;
            position: absolute;
        }
        input:checked ~ button {
          background-color: var(--principal);
          color: #fff;
          span {
            span {
              color: #fff;
            }
          }
        }
        >div {
          margin-right: 20px;
        }
        label {
          display: flex;
          align-items: center;
          justify-content: center;
          input {
            margin: 0;
          }
          span {
            font-size: 1.37rem;
            font-weight: 500;
            padding: 5px 10px;
            position: relative;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            span {
              font-size: 1.5rem;
              font-weight: 700;
              color: var(--principal);
            }
          }
        }
      }
    }
  }
  // .mobile .productModal .options__wrapper .option .options button {
  //   color: var(--iconsColor1);
  //   background: var(--iconsColor2);
  // }
  // .productModal .options__wrapper .option .options input:checked~button {
  //   color: var(--iconsColor2);
  //   background: var(--iconsColor1);
  // }
</style>
